import type { App } from 'vue'
import antdVComponents from './antdVComps/components'
import './antdVComps/style'

import BasicModal from './BasicModal.vue'
import SvgIcon from './SvgIcon.vue'

const components = [BasicModal, SvgIcon]

export default function registerGlobalComponents(app: App) {
  antdVComponents.forEach((component) => {
    if (component.install) {
      app.use(component)
    }
  })
  components.forEach((component) => {
    app.component(component.name || component.displayName, component)
  })
  return app
}
